import { AnyAction, combineReducers } from 'redux';
import { FetchStatus } from '../appState';
import { Banner } from '../../hexagon/models/BannerModel';

export const data = (state: Banner = {} as Banner, action: AnyAction) => {
    if (action.type === 'banner/bannerReceived') {
        return action.payload.banner;
    }
    return state;
};

export const status = (state: FetchStatus = 'idle', action: AnyAction) => {
    if (action.type === 'banner/bannerRequested') return 'loading';
    if (action.type === 'banner/bannerReceived') return 'succeeded';
    if (action.type === 'banner/bannerRequestFailed') return 'failed';

    return state;
};

export const bannerReducer = combineReducers({
    status,
    data,
});
